import React from 'react';
import PropTypes from 'prop-types';
import {Grid, Typography, Divider} from '@material-ui/core';


/**
 * This function will display our aim and our path
 * @param props {object} : props, contains the title of this section
 * @return {*}
 * @constructor
 */
export default function Main(props) {
    const {title} = props;

    return (
        <Grid item xs={12} md={8}>
            <Typography variant="h6" gutterBottom>
                {title}
            </Typography>
            <Divider/>
            <Typography variant="h6" gutterBottom>
                Parcours
            </Typography>
            <Typography style={{marginBottom: 10}}>
                Nous avons découvert la programmation durant notre année de terminale scientifique.

                Nous avions eu l’occasion de programmer en HTML et en CSS et pû ainsi découvrir ce qui est possible de
                créer en maîtrisant le code informatique…C’est-à-dire à peu près tout !

                La programmation d’un jeu en langage python nous a totalement fascinés. Là est née notre envie de
                développer nos compétences dans ce domaine.

                Véritable passion, Nous actualisons tous les jours nos connaissances sur les technologies liées à
                l’informatique, notamment sur les ordinateurs quantiques, l'intelligence artificielle, les objets
                connectés et le principe de la shadow box.

                L’informatique n’est pas un travail nous mais une véritable passion !

            </Typography>
            <Typography variant="h6" gutterBottom>
                Pourquoi
            </Typography>
            <Typography variant='body2' style={{margin: 10}}>
                Pourquoi lutter contre le gaspillage alimentaire ?
            </Typography>
            <Typography paragraph={true}>
                Tous les ans, chaque personne vivant en France jette en moyenne 29kg de nourriture encore
                consommable1
                (dont 7 kg encore emballées...). Ce gaspillage revêt plusieurs dimensions. Il s’agit
                d’un gaspillage de ressources et d’énergie, puisque des aliments qui ont été produits, transportés,
                et emballés sont finalement jetés, mais également un gaspillage d’argent : l’ADEME estime la
                valeur de cette nourriture gaspillée à 108 euros par an et par personne. Limiter le gaspillage
                alimentaire est également une démarche éthique, dans un monde où, ne serait-ce qu’en France, 6
                millions de personnes ne peuvent se nourrir en quantité ou en qualité suffisante.
                D’une manière générale, mesurer le gaspillage alimentaire permet d’en prendre conscience et,
                ensuite, d’ouvrir le dialogue avec ses proches sur la valeur que l’on accorde à l’alimentation. En
                augmentant cette valeur, notamment symbolique, les actions correctives découlent naturellement.
                Au moment de l’achat
            </Typography>
            <Typography variant='body2' style={{margin: 10}}>
                Objectif : acheter au plus près de ses besoins et de façon éco-responsable
                Comment ?
            </Typography>
            <Typography paragraph={true}>
                ✔ Ne pas faire les courses en ayant faim : faire ses courses le ventre vide peut encourager
                les achats irréfléchis de produits dont on n’a pas nécessairement besoin, accentuant la
                tentation d’acheter des aliments gras ou sucrés et/ou en trop grande quantité.<br/><br/>
                ✔ Faire une liste afin de limiter vos achats.<br/><br/>
                ✔ Acheter les produits et les quantités correspondant à vos besoins et vos goûts, en
                fonction du nombre de repas et de convives. Par exemple, si vous vivez seul, privilégiez de
                plus petites quantités voire des portions individuelles.<br/><br/>
                ✔ Etre attentif aux dates de péremption, en particulier à la date limite de consommation
                (DLC) : n’achetez un produit que si vous êtes certain de pouvoir le consommer avant cette
                date limite.
            </Typography>
            <Typography variant='body2' style={{margin: 10}}>
                Bon à savoir : la différence entre « DLC » et « DDM » :
            </Typography>
            <Typography paragraph={true}>
                - La DLC (date limite de consommation) figure sur les produits frais, et indique la date à ne pas
                dépasser pour des raisons de sécurité sanitaire : elle s’exprime sous la forme de la mention « à
                consommer avant ».<br/><br/>
                - Au contraire, la DDM (date de durabilité minimale, ex-date limite d’utilisation optimale ou
                DLUO) n’indique pas la date à partir de laquelle le produit n’est plus consommable, mais la date à
                partir de laquelle ses caractéristiques telles que le goût, l’odeur, ou encore la texture sont
                susceptibles d’évoluer. La DDM informe sur la qualité du produit et se caractérise par l’expression
                « à consommer de préférence avant le ». Vous pouvez manger sans aucun risque pour votre
                santé tout produit qui aurait dépassé ce type de date.
            </Typography>
        </Grid>
    );
}

Main.propTypes = {
    posts: PropTypes.array,
    title: PropTypes.string,
};
